import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.99998 14.4016C11.5346 14.4016 14.4 11.5362 14.4 8.00156C14.4 4.46694 11.5346 1.60156 7.99998 1.60156C4.46535 1.60156 1.59998 4.46694 1.59998 8.00156C1.59998 11.5362 4.46535 14.4016 7.99998 14.4016Z",
  fill: "#22863D"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.40796 8.00144L7.13596 9.72944L10.592 6.27344",
  stroke: "white",
  "stroke-width": "1.336",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1);
const _hoisted_4 = [_hoisted_2, _hoisted_3];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 16 16",
    fill: "none"
  }, _hoisted_4, 8, _hoisted_1);
}